export default events
export const {
  EventEmitter,
} = events